// Product Badges Variant Handler
// Updates product image badges based on variant metafields

document.addEventListener('DOMContentLoaded', function () {
  // Find the badge containers on product images
  const badgeContainers = document.querySelectorAll('.product__badges');

  if (badgeContainers.length === 0) {
    return;
  }

  // Load badge priorities from theme settings
  function loadBadgePriorities() {
    const priorityScript = document.querySelector('[data-badge-priorities]');
    if (priorityScript) {
      try {
        const priorities = JSON.parse(priorityScript.textContent);
        return {
          SOLD_OUT: priorities.sold_out || 1,
          COMING_SOON: priorities.coming_soon || 2,
          CLEARANCE: priorities.clearance || 3,
          ORDER_IN: priorities.order_in || 3,
          SALE: priorities.sale || 4,
          PACK_PRICE: priorities.pack_price || 5,
          ONLINE_ONLY: priorities.online_only || 6,
          PREORDER: priorities.preorder || 7,
          NEW_IN: priorities.new_in || 8,
          NEW: priorities.new || 9,
          CUSTOM: priorities.custom || 1,
        };
      } catch (e) {
        console.error('Failed to parse badge priorities:', e);
      }
    }

    // Fallback to default values if script not found
    return {
      SOLD_OUT: 1,
      COMING_SOON: 2,
      CLEARANCE: 3,
      ORDER_IN: 3,
      SALE: 4,
      PACK_PRICE: 5,
      ONLINE_ONLY: 6,
      PREORDER: 7,
      NEW_IN: 8,
      NEW: 9,
      CUSTOM: 1,
    };
  }

  // Load priorities once on init
  const PRIORITY = loadBadgePriorities();

  // Function to build badges HTML based on variant
  function buildBadgesHTML(variant) {
    if (!variant) {
      return '';
    }

    const badgesWithPriority = [];
    const metafields = variant.metafields?.custom || {};

    // Check for sold out badge
    let isAvailable = variant.available;
    if (metafields.exo_out_of_stock_xtra_field === false) {
      isAvailable = true;
    }

    if (!isAvailable) {
      badgesWithPriority.push({
        priority: PRIORITY.SOLD_OUT,
        html: '<span class="badge badge--sold-out">Sold Out</span>',
      });
    }

    // Check each badge type and add to array with priority
    if (metafields.exo_coming_soon === true) {
      badgesWithPriority.push({
        priority: PRIORITY.COMING_SOON,
        html: '<span class="badge badge--coming-soon">Coming Soon</span>',
      });
    }

    if (metafields.exo_clearance === true) {
      badgesWithPriority.push({
        priority: PRIORITY.CLEARANCE,
        html: '<span class="badge badge--clearance">Clearance</span>',
      });
    }

    if (metafields.exo_order_in_xtra_field === true) {
      badgesWithPriority.push({
        priority: PRIORITY.ORDER_IN,
        html: '<span class="badge badge--order-in">Order In</span>',
      });
    }

    // Check for sale badge
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      badgesWithPriority.push({
        priority: PRIORITY.SALE,
        html: '<span class="badge badge--sale">Sale</span>',
      });
    }

    if (metafields.exo_pack_price === true) {
      badgesWithPriority.push({
        priority: PRIORITY.PACK_PRICE,
        html: '<span class="badge badge--pack-price">Pack Price</span>',
      });
    }

    // Handle "New" badge - check if product date is within 6 months
    if (metafields.exo_new_product_flag) {
      const productDate = new Date(metafields.exo_new_product_flag);
      const currentDate = new Date();
      const sixMonthsInMs = 15778800000; // 6 months in milliseconds
      const dateDiff = currentDate - productDate;

      if (dateDiff >= 0 && dateDiff <= sixMonthsInMs) {
        badgesWithPriority.push({
          priority: PRIORITY.NEW,
          html: '<span class="badge badge--new">New</span>',
        });
      }
    }

    // Check for custom badge JSON metafield (can be array or null)
    const customBadgeData = metafields?.custom_badge;
    if (Array.isArray(customBadgeData)) {
      // Handle array of custom badges
      customBadgeData.forEach((badgeItem) => {
        if (badgeItem?.badge_label) {
          const bgColor = badgeItem.badge_color || '';
          const textColor = badgeItem.badge_text_color || '';
          const badgePriority = badgeItem.badge_priority || PRIORITY.CUSTOM;

          // Basic color validation (allow hex, rgb/rgba, named colors)
          const isValidColor = (color) => {
            if (!color) return true;
            return /^(#([0-9A-F]{3}){1,2}|rgb|rgba|[a-z]+)/i.test(color);
          };

          if (isValidColor(bgColor) && isValidColor(textColor)) {
            let styleAttr = '';
            if (bgColor) styleAttr += `background-color: ${bgColor};`;
            if (textColor) styleAttr += `color: ${textColor};`;

            badgesWithPriority.push({
              priority: badgePriority,
              html: `<span class="badge badge--custom"${styleAttr ? ` style="${styleAttr}"` : ''}>${badgeItem.badge_label}</span>`,
            });
          }
        }
      });
    }

    // Sort badges by priority (lower number = higher priority)
    badgesWithPriority.sort((a, b) => a.priority - b.priority);

    // Return all badges in priority order (PDP shows all badges)
    return badgesWithPriority.map((badge) => badge.html).join('');
  }

  // Function to update all badge containers
  function updateBadges(variant) {
    const badgesHTML = buildBadgesHTML(variant);

    // Re-query containers in case DOM has changed
    const currentContainers = document.querySelectorAll('.product__badges');

    currentContainers.forEach((container) => {
      container.innerHTML = badgesHTML;
    });
  }

  // Listen for variant changes
  document.addEventListener('theme:variant:change', function (event) {
    const { variant } = event.detail;

    // Update immediately to minimize flash
    updateBadges(variant);

    // Also update after a delay to catch any late image swaps
    setTimeout(() => {
      updateBadges(variant);
    }, 50);

    // And one more time after animations complete
    setTimeout(() => {
      updateBadges(variant);
    }, 200);
  });

  // Update badges on initial page load to ensure all badge containers are consistent
  // Get initial variant from product JSON
  const productJson = document.querySelector('[data-product-json]');
  if (productJson) {
    try {
      const product = JSON.parse(productJson.textContent);
      const hiddenVariantInput = document.querySelector('input[name="id"]');
      const selectedVariantId = hiddenVariantInput ? parseInt(hiddenVariantInput.value) : null;

      const initialVariant = selectedVariantId
        ? product.variants.find((v) => v.id === selectedVariantId)
        : product.variants.find((v) => v.available) || product.variants[0];

      if (initialVariant && window.variantMetafieldsHelper) {
        window.variantMetafieldsHelper.enrichVariant(initialVariant);
        updateBadges(initialVariant);
      }
    } catch (e) {
      console.error('Error initializing badges:', e);
    }
  }
});
